import {
  Box,
  Typography,
  Card,
  CardContent,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';
import {
  ActionLink,
  ActionLinkBack,
} from '@features/workspace/components/controls/action-link';
import history from '@app/services/history';
import { useAppSelector } from '@store/hooks';
import { selectUsersData } from '@features/workspace/store/selectors';
import { EmployeePositionLabelEnum } from '@utils/constants';
import { FC } from 'react';

interface IProps {
  backUri: string;
}

interface IRow {
  name: string;
  userId: string;
  role: string;
  verified: string;
  adminRights: string;
  dateAdded: string;
  dateRemoved: string;
}

const UsersArchive: FC<IProps> = ({ backUri }) => {
  const onGoBack = () => {
    history.push(backUri);
  };

  const users = useAppSelector(selectUsersData);

  const rows: IRow[] = users.map((user) => ({
    name: [user?.person?.firstName, user?.person?.lastName].join(' '),
    userId: user.id ?? '',
    role: user?.assignment?.position
      ? EmployeePositionLabelEnum[user?.assignment?.position]
      : 'N/A',
    verified:
      user?.person?.identityDocuments?.[0]?.isVerified &&
      user?.address?.jumioIsVerified
        ? 'Yes'
        : 'No',
    adminRights: 'Manager',
    dateAdded: 'N/A', // moment(user.createdAt).format('D MMM YYYY'),
    dateRemoved: 'N/A',
  }));

  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Box alignItems="center" display="flex" pb={5} pt={3} px={4}>
        <Box display="flex" mr={2}>
          <ActionLinkBack onClick={onGoBack}>Back</ActionLinkBack>
        </Box>
      </Box>
      <Box display="flex" flexGrow={1}>
        <Card style={{ width: '100%' }}>
          <CardContent>
            <Box display="flex" flexDirection="column" flexGrow={1} py={2}>
              <Box display="flex">
                <Typography variant="legend">Account user archive</Typography>
              </Box>
              <Box display="flex" mt={3}>
                <Table aria-label="simple table" width="100%">
                  <TableHead>
                    <TableRow>
                      <TableCell>User</TableCell>
                      <TableCell>user ID</TableCell>
                      <TableCell>Role</TableCell>
                      <TableCell>Verified</TableCell>
                      <TableCell>Admin rights</TableCell>
                      <TableCell>Date added</TableCell>
                      <TableCell>Date removed</TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row) => (
                      <TableRow
                        key={row.userId}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.name}
                        </TableCell>
                        <TableCell>{row.userId}</TableCell>
                        <TableCell>{row.role}</TableCell>
                        <TableCell>{row.verified}</TableCell>
                        <TableCell>{row.adminRights}</TableCell>
                        <TableCell>{row.dateAdded}</TableCell>
                        <TableCell>{row.dateRemoved}</TableCell>
                        <TableCell>
                          <ActionLink>Reinstate user</ActionLink>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default UsersArchive;
